import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { BondPolicyNumberDto, bondPolicyNumberValidationSchema } from 'dtos'
import { Formik } from 'formik'
import { ExplanationAccordion } from 'components'

interface BondPolicyNumberAddEditDialogProps {
  initialValues: BondPolicyNumberDto
  isLoading: boolean
  onClose: () => void
  onSave: (values: BondPolicyNumberDto) => void
  open: boolean
}

export default function BondPolicyNumberAddEditDialog({
  initialValues,
  isLoading,
  onClose,
  onSave,
  open
}: BondPolicyNumberAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={false}
        validationSchema={bondPolicyNumberValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Add Bond Policy Numbers</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(touched.blockStart && errors.blockStart)}
                      helperText={touched.blockStart && errors.blockStart}
                      label='Start'
                      name='blockStart'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='number'
                      value={values.blockStart}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(touched.blockEnd && errors.blockEnd)}
                      helperText={touched.blockEnd && errors.blockEnd}
                      label='End'
                      name='blockEnd'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='number'
                      value={values.blockEnd}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <ExplanationAccordion variant='outlined'>||All fields are required. ||</ExplanationAccordion>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={isLoading || isSubmitting} color='inherit' onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton color='primary' loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
